import { render } from "./course-menu.vue?vue&type=template&id=c14b4482&scoped=true"
import script from "./course-menu.vue?vue&type=script&lang=js"
export * from "./course-menu.vue?vue&type=script&lang=js"

import "./course-menu.vue?vue&type=style&index=0&id=c14b4482&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c14b4482"]])

export default __exports__